const screenInputData = {
  TalepForm: [{"name":"IssueID","type":"Guid","cardinality":1,"isExpandedPanel":null}],
	BayiProfil: [{"name":"DealerID","type":"Guid","cardinality":1,"isExpandedPanel":null}],
	HedefTanim: [{"name":"ID","type":"Guid","cardinality":1,"isExpandedPanel":null}],
	BayiTanim: [{"name":"Id","type":"Guid","cardinality":1,"isExpandedPanel":null}],
	HedefTipiTanim: [{"name":"Id","type":"Guid","cardinality":1,"isExpandedPanel":null}],
	FotoDrawer: [{"name":"sessionName","type":"String","cardinality":1,"isExpandedPanel":null}],
	TalepDetay: [{"name":"IssueID","type":"Guid","cardinality":1,"isExpandedPanel":null}],
	KampanyaForm: [{"name":"Id","type":"Guid","cardinality":1,"isExpandedPanel":null}],
	BayiBelgeList: [{"name":"DealerID","type":"Guid","cardinality":1,"isExpandedPanel":null}],
	KullaniciDetay: [{"name":"UserName","type":"String","cardinality":1,"isExpandedPanel":null}],
	KampanyaDetay: [{"name":"CampaignID","type":"Guid","cardinality":1,"isExpandedPanel":null}],
	TalepBelgeForm: [{"name":"Id","type":"Guid","cardinality":1,"isExpandedPanel":null},{"name":"IssueID","type":"Guid","cardinality":1,"isExpandedPanel":null}],
	HedefGerceklesmeOran: [{"name":"GoalD","type":"Guid","cardinality":1,"isExpandedPanel":null},{"name":"DealerID","type":"Guid","cardinality":1,"isExpandedPanel":null}],
	TalepBelgeList: [{"name":"IssueD","type":"Guid","cardinality":1,"isExpandedPanel":null}],
	KullaniciForm: [{"name":"IsEdit","type":"Boolean","cardinality":1,"isExpandedPanel":null},{"name":"UserName","type":"String","cardinality":1,"isExpandedPanel":null}],
	NewPass: [{"name":"PrmUserName","type":"String","cardinality":1,"isExpandedPanel":null}],
	DealerBadges_Form: [{"name":"Id","type":"Guid","cardinality":1,"isExpandedPanel":"false"}],
	BayiBelgeForm: [{"name":"Id","type":"Guid","cardinality":1,"isExpandedPanel":null},{"name":"DealerID","type":"Guid","cardinality":1,"isExpandedPanel":null}]
};

export class ScreenInputHelper {
  public static getScreenInputValue(screenName: string, inputName: string, value: string): any {
    switch (this.getScreenInputType(screenName, inputName)) {
      case "String":
        return value;
      case "Boolean":
        return value.toLowerCase() === "true";
      // TODO
    }

    return value;
  }

  private static getScreenInputType(screenName: string, inputName: string): string {
    const data = screenInputData[screenName]?.find((x) => x.Name === inputName);
    return data?.TypeName ? data.TypeName : "";
  }
}
